export default __webpack_public_path__ + "static/media/map-pin.4ebc200c.svg";